import * as end from '../constants/api'
import { axiosInstance } from './axios-instance'

const AuditServices = {
	getEvent: () => {
		return axiosInstance.get(end.getEvent).then(res => res.data)
	},
	saveEventRegistry: ({ payload, userId }) =>
		payload?.eventName &&
		axiosInstance.post(end.saveEventRegistry({ userId }), payload).then(res => res.data)
}

export default AuditServices
